import { put } from 'redux-saga/effects';
import { Notifications } from 'types';
import { OnPlayerResultData } from '../types';
import { setWinStatusAction } from 'core/widgets/WinStatus/actions';

export function* onPlayerResultSaga({ type: notificationType, data: result }: OnPlayerResultData) {
  if (notificationType === Notifications.PLAYER_RESULT) {
    const { winAmount, drawResult } = result;
    yield put(
      setWinStatusAction({
        winner: drawResult.toString(),
        winningAmount: winAmount || 0,
      }),
    );
  }
}
